import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { BackgroundPreloadService } from "./shared/services/background-preload/background-preload.service";
import { AppRoutingConstants } from "./app-routing.constants";
import { CreateApplicationRoutingConstants } from "./create-application/create-application-routing.constants";
import { AuthGuard } from "./shared/guards/auth-guard/auth.guard";
import { aflaModuleServiceProvider } from "./shared/services/afla-module-strategy/afla-module-strategy.service.provider";
import { SearchApplicationsRoutingConstants } from "./search-applications/search-applications-routing.constants";
import { RefreshComponent } from "./create-application/shared/refresh/refresh.component";
import { DocumentsAndInformationRoutingConstants } from "./documents-and-information/documents-and-information-routing.constants";
import { ViewApplicationRoutingConstants } from "./view-application/view-application-routing.constants";
import { RefreshViewApplicationComponent } from "./core/refresh/refresh-view-application/refresh-view-application.component";
import { MapRoutingConstants } from "./map/map-routing.constants";
import { LogoutComponent } from "./core/logout/logout.component";
import { MaintenanceGuard } from "./shared/guards/maintenance-gaurd/maintenance.guard";
import { MaintenanceModeComponent } from "./shared/components/maintenance-mode/maintenance-mode.component";
const routes = [{
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, MapRoutingConstants.ESRI_MAP_ROUTE),
        loadChildren: () => import("./map/map.module").then(mod => mod.MapModule),
        canActivate: [AuthGuard, MaintenanceGuard],
        data: { preload: true }
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE),
        loadChildren: () => import("./create-application/create-application.module").then(module => module.CreateApplicationModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE),
        loadChildren: () => import("./view-application/view-application.module").then(module => module.ViewApplicationModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, DocumentsAndInformationRoutingConstants.VIEW_DOCUMENTS_AND_INFORMATION_ROUTE),
        loadChildren: () => import("./documents-and-information/documents-and-information.module").then(module => module.DocumentsAndInformationModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(SearchApplicationsRoutingConstants.SEARCH_APPLICATIONS_ROUTE),
        loadChildren: () => import("./search-applications/search-applications.module").then(module => module.SearchApplicationsModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE,
        component: RefreshViewApplicationComponent,
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.REFRESH_ROUTE, component: RefreshComponent, canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.LOGOUT_ROUTE, component: LogoutComponent
    }, {
        path: AppRoutingConstants.MAINTENANCE_PATH, component: MaintenanceModeComponent, pathMatch: AppRoutingConstants.PATH_MATCH_FULL
    }];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            RouterModule.forRoot(routes, {
                preloadingStrategy: BackgroundPreloadService
            }),
            CommonModule
        ],
        exports: [RouterModule],
        providers: [aflaModuleServiceProvider]
    })
], AppRoutingModule);
export { AppRoutingModule };
